import { createFileRoute, redirect } from '@tanstack/react-router';

import { PublicHomePage } from '~/features/public-home/pages/public-home-page';
import { useAuthStore } from '~/store/auth.store';

/**
 * Public homepage at `/`. Google OAuth verification requires a homepage that loads
 * without sign-in and names the app, so anonymous visitors get `PublicHomePage`;
 * signed-in users go straight to the post-login dispatcher at `/home`.
 * Auth is already hydrated here — `AppBootstrap` holds the router until it settles.
 */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    if (useAuthStore.getState().isAuthenticated) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing a redirect
      throw redirect({ to: '/home' });
    }
  },
  component: PublicHomePage,
});
